import React, { useState } from 'react';
import jsPDF from 'jspdf';
import { FaImage, FaFilePdf, FaPalette, FaBook, FaSpinner, FaFont, FaExpandArrowsAlt } from 'react-icons/fa';

const CoverGenerator = () => {
  // ?? ????? 5x8 ?? ????? ????????? ??
  const [trimSize, setTrimSize] = useState({ width: 5, height: 8 });
  const [pageCount, setPageCount] = useState(150);
  const [spineColor, setSpineColor] = useState('#130f40'); 
  const [frontCover, setFrontCover] = useState(null);
  const [backCover, setBackCover] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);

  const [spineText1, setSpineText1] = useState('');
  const [spineText2, setSpineText2] = useState('');
  const [spineText3, setSpineText3] = useState('');
  const [spineTextColor, setSpineTextColor] = useState('#ffffff');

  // ?????? ??????? ???????
  const sizeOptions = [
    { label: "5 x 8 in (Pocket Size - Default)", width: 5, height: 8 },
    { label: "6 x 9 in (Standard Novel)", width: 6, height: 9 },
    { label: "8.5 x 11 in (Large Print)", width: 8.5, height: 11 }
  ];

  const handleImageUpload = (e, setCover) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCover(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const generateCoverPDF = () => {
    if (!frontCover || !backCover) {
      alert("Please upload both Front and Back cover images!");
      return;
    }
    
    setIsGenerating(true);

    try {
      const bleedInch = 0.125; 
      const trimWidthInch = trimSize.width;
      const trimHeightInch = trimSize.height;
      
      // ???? ??? ?????? ?????? ????? ??? ??? ??????? (Black & White Paper)
      const spineWidthInch = pageCount * 0.002252; 
      
      const fullWidthInch = bleedInch + trimWidthInch + spineWidthInch + trimWidthInch + bleedInch;
      const fullHeightInch = trimHeightInch + (2 * bleedInch);

      const inchToMm = 25.4;
      const bleedMm = bleedInch * inchToMm;
      const trimWidthMm = trimWidthInch * inchToMm;
      const trimHeightMm = trimHeightInch * inchToMm; // ? ??? ????? ?? ???? ??? ????
      const spineWidthMm = spineWidthInch * inchToMm;
      const fullWidthMm = fullWidthInch * inchToMm;
      const fullHeightMm = fullHeightInch * inchToMm;

      const doc = new jsPDF('landscape', 'mm', [fullWidthMm, fullHeightMm]);

      // ??? ??? ???????
      doc.setFillColor(spineColor);
      doc.rect(0, 0, fullWidthMm, fullHeightMm, 'F');

      // ????? ?????? ??????
      doc.addImage(backCover, 'JPEG', bleedMm, bleedMm, trimWidthMm, trimHeightMm);

      // ????? ?????? ???????
      const frontXPosition = bleedMm + trimWidthMm + spineWidthMm;
      doc.addImage(frontCover, 'JPEG', frontXPosition, bleedMm, trimWidthMm, trimHeightMm);

      // Spine Text Logic
      const activeTexts = [spineText1, spineText2, spineText3].filter(t => t.trim() !== '');
      
      if (activeTexts.length > 0 && pageCount >= 79) {
        const spineLeftEdge = bleedMm + trimWidthMm;
        const spineCenterX = spineLeftEdge + (spineWidthMm / 2);
        
        const yTop = bleedMm + (fullHeightMm * 0.2); 
        const yCenter = fullHeightMm / 2; 
        const yBottom = fullHeightMm - bleedMm - (fullHeightMm * 0.2); 
        
        doc.setTextColor(spineTextColor);
        doc.setFont("helvetica", "bold");
        
        const safeSpineWidth = spineWidthMm - 2; 
        let safeFontSize = Math.floor(safeSpineWidth * 2.834); 
        if (safeFontSize > 18) safeFontSize = 18; 
        if (safeFontSize < 6) safeFontSize = 6;   
        
        const fontHeightMm = safeFontSize / 2.834;
        const exactX = spineCenterX + (fontHeightMm * 0.35);

        const drawSpineText = (text, centerY) => {
          doc.setFontSize(safeFontSize);
          let textWidthMm = doc.getTextWidth(text);
          
          const maxTextLengthMm = fullHeightMm * 0.3; 
          let localFontSize = safeFontSize;
          
          if (textWidthMm > maxTextLengthMm) {
              localFontSize = Math.floor((maxTextLengthMm / textWidthMm) * safeFontSize);
              doc.setFontSize(localFontSize);
              textWidthMm = doc.getTextWidth(text);
          }

          const exactY = centerY + (textWidthMm / 2);
          doc.text(text, exactX, exactY, { angle: 90 });
        };

        if (activeTexts.length === 1) {
          drawSpineText(activeTexts[0], yCenter);
        } else if (activeTexts.length === 2) {
          drawSpineText(activeTexts[0], yTop);
          drawSpineText(activeTexts[1], yBottom);
        } else if (activeTexts.length === 3) {
          drawSpineText(activeTexts[0], yTop);
          drawSpineText(activeTexts[1], yCenter);
          drawSpineText(activeTexts[2], yBottom);
        }
      }

      doc.save(`KDP_Cover_${trimSize.width}x${trimSize.height}_${pageCount}p.pdf`);
      
    } catch (error) {
      console.error("Error generating cover:", error);
      alert("Failed to generate cover.");
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>?? KDP Cover Auto-Builder</h2>
      <p style={styles.subtitle}>Choose your size, upload images, and we'll calculate the bleed and spine automatically.</p>

      <div style={styles.grid}>
        
        <div style={styles.card}>
          <h3 style={styles.cardTitle}><FaBook /> Book Configuration</h3>
          
          <div style={styles.inputGroup}>
            <label style={styles.label}><FaExpandArrowsAlt /> Trim Size</label>
            <select 
              style={styles.input} 
              value={`${trimSize.width}x${trimSize.height}`}
              onChange={(e) => {
                const [w, h] = e.target.value.split('x').map(Number);
                setTrimSize({ width: w, height: h });
              }}
            >
              {sizeOptions.map(opt => (
                <option key={opt.label} value={`${opt.width}x${opt.height}`}>{opt.label}</option>
              ))}
            </select>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Number of Pages</label>
            <input 
              type="number" 
              value={pageCount} 
              onChange={(e) => setPageCount(Number(e.target.value))} 
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}><FaPalette /> Spine/Background Color</label>
            <div style={{display: 'flex', gap: 10}}>
              <input type="color" value={spineColor} onChange={(e) => setSpineColor(e.target.value)} style={styles.colorPicker}/>
              <input type="text" value={spineColor} onChange={(e) => setSpineColor(e.target.value)} style={{...styles.input, flex: 1}}/>
            </div>
          </div>
        </div>

        <div style={styles.card}>
          <h3 style={styles.cardTitle}><FaImage /> Upload Artwork</h3>
          <p style={{fontSize: '12px', color: '#e17055', marginBottom: '10px'}}>Note: Upload images matching {trimSize.width}x{trimSize.height} size.</p>
          <div style={styles.uploadGrid}>
            <div style={styles.uploadBox}>
              <label style={styles.label}>Back</label>
              <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, setBackCover)} style={styles.fileInput} />
              {backCover && <img src={backCover} alt="Back" style={styles.previewImg} />}
            </div>
            <div style={styles.uploadBox}>
              <label style={styles.label}>Front</label>
              <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, setFrontCover)} style={styles.fileInput} />
              {frontCover && <img src={frontCover} alt="Front" style={styles.previewImg} />}
            </div>
          </div>
        </div>
      </div>

      <div style={{...styles.card, marginTop: '20px'}}>
        <h3 style={styles.cardTitle}><FaFont /> Spine Text (Min 79 pages)</h3>
        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 100px', gap: '15px'}}>
          <input type="text" placeholder="Title" value={spineText1} onChange={(e) => setSpineText1(e.target.value)} style={styles.input} disabled={pageCount < 79}/>
          <input type="text" placeholder="Subtitle" value={spineText2} onChange={(e) => setSpineText2(e.target.value)} style={styles.input} disabled={pageCount < 79}/>
          <input type="text" placeholder="Author" value={spineText3} onChange={(e) => setSpineText3(e.target.value)} style={styles.input} disabled={pageCount < 79}/>
          <input type="color" value={spineTextColor} onChange={(e) => setSpineTextColor(e.target.value)} style={{...styles.colorPicker, width: '100%'}} disabled={pageCount < 79}/>
        </div>
      </div>

      <div style={{textAlign: 'center', marginTop: 30}}>
        <button onClick={generateCoverPDF} disabled={isGenerating} style={styles.downloadBtn}>
          {isGenerating ? <><FaSpinner className="icon-spin"/> Building PDF...</> : <><FaFilePdf /> Download {trimSize.width}x{trimSize.height} Cover</>}
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '30px', maxWidth: '1000px', margin: '0 auto', fontFamily: "'Segoe UI', sans-serif" },
  title: { color: '#2d3436', marginBottom: 5 },
  subtitle: { color: '#636e72', marginBottom: 30 },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1.2fr', gap: '20px' },
  card: { background: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', border: '1px solid #eee' },
  cardTitle: { display: 'flex', alignItems: 'center', gap: '8px', marginTop: 0, marginBottom: 20, color: '#2d3436', borderBottom: '1px solid #eee', paddingBottom: 10 },
  inputGroup: { marginBottom: '20px' },
  label: { display: 'flex', alignItems: 'center', gap: 5, marginBottom: '8px', fontWeight: 'bold', color: '#2d3436', fontSize: '14px' },
  input: { width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #dfe6e9', fontSize: '14px' },
  colorPicker: { width: '50px', height: '40px', padding: 0, border: 'none', cursor: 'pointer', borderRadius: '6px' },
  uploadGrid: { display: 'flex', gap: '15px' },
  uploadBox: { flex: 1, background: '#f8f9fa', padding: '15px', borderRadius: '8px', border: '1px dashed #b2bec3', textAlign: 'center' },
  fileInput: { width: '100%', fontSize: '12px', marginBottom: 10 },
  previewImg: { width: '100%', height: '140px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #dfe6e9' },
  downloadBtn: { background: '#0984e3', color: 'white', border: 'none', padding: '15px 40px', borderRadius: '30px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '10px', boxShadow: '0 5px 15px rgba(9, 132, 227, 0.3)' }
};

export default CoverGenerator;